module.exports = __webpack_public_path__ + "static/img/xp-draw-modal.dcd238c6.png";